import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
	data: {},
	error: undefined,
	hasBeenSubmitted: false,
	isSubmitting: false
};

export const checkoutSlice = createSlice({
	name: 'checkout',
	initialState,
	reducers: {
		submitCheckout: (state) => {
			state.isSubmitting = true;
		},
		submitCheckoutCompleted: (state, action) => {
			state.isSubmitting = false;
			state.hasBeenSubmitted = true;
			state.data = action.payload;
		},
		submitCheckoutFailed: (state, action) => {
			state.isSubmitting = false;
			state.error = action.payload;
		},
		resetCheckout: () => {
			return initialState;
		}
	}
});

export const {
	resetCheckout,
	submitCheckout,
	submitCheckoutCompleted,
	submitCheckoutFailed
} = checkoutSlice.actions;

export default checkoutSlice.reducer;
